import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { ProductOperator } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props extends Omit<SelectProps<ProductOperator>, 'items' | 'onSelect'> {
  onChange?: (value: ProductOperator) => void
}

const OperatorSelect = (props: Props) => {
  const { onChange, value, ...otherProps } = props

  const operators = [
    ProductOperator.Vodafone,
    ProductOperator.Telenet,
    ProductOperator.Telenor,
    ProductOperator.Proximus,
  ]

  const items = operators.map((operator) => ({
    value: ProductOperator[operator],
    title: ProductOperator[operator],
  }))

  return (
    <Select
      style={styles.container}
      onSelect={onChange}
      items={items}
      testID="OperatorSelect.Container"
      value={value}
      {...otherProps}
    />
  )
}

export default OperatorSelect
